
import { ResultData } from "@nt-portal/common-sdk";

import { AuditHistory, BulkUpdateRequest, DataQuery, TCMResponseDataItem, TCMResponseDataService, TCMResponseItemRanking, TCMResponseValidation } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";

export interface TCMResponseDataItemOptions extends ControllerOptions<TCMResponseDataItem> {
    importMode?: string;
    scheduleId?: string;
    responseId?: string;
    rowId?: string;
    dataQuery?: DataQuery;
}

export const initTCMResponseDataItem = (inObj: Partial<TCMResponseDataItem>) => {
    let item: TCMResponseDataItem = {
        id: "",
        ranking: 0,
        price: 0
    }
    return item;
}


export class ClientTCMResponseDataItemService extends BaseClientService implements DataController<TCMResponseDataItem> {

    private _service: TCMResponseDataService;


    constructor() {
        super();
        this._service = new TCMResponseDataService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }


    public init(inObj: Partial<TCMResponseDataItem>): TCMResponseDataItem {
        return initTCMResponseDataItem(inObj);
    }

    public async get(options: TCMResponseDataItemOptions): Promise<ResultData<TCMResponseDataItem>> {


        if (options.scheduleId) {
            this._service.params.scheduleId = options.scheduleId;
            return await this._service.getByFilter(this.buildFetchParams(options), this.token, options.dataQuery);
        } else {
            throw new Error("Schedule ID is required to fetch response items.");
        }


    }
    public async getLookup(options: TCMResponseDataItemOptions): Promise<ResultData<TCMResponseDataItem>> {


        if (this.params.scheduleId) {
            let fetchParams = this.buildLookupFetchParams(options);
            let data = await this._service.getByFilter(fetchParams, this.token, {
                filter: {
                    condition: "and",
                    expressions: []
                },
                sort: []
            });
            return data;
        }
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }



    public async update(options: TCMResponseDataItemOptions): Promise<TCMResponseDataItem | TCMResponseDataItem[] | null> {
        if (options.item && options.item.id && this.params.scheduleId)
            return await this._service.update(this.token, options.item.id, options.item)
        return null;
    }

    public async validate(options: TCMResponseValidation): Promise<any> {
        if (this.params.scheduleId) {
            return await this._service.validateItems(options, this.token);
        }
    }


    public async ranking(options: TCMResponseItemRanking) {
        if (this.params.scheduleId) {
            return await this._service.rankItems(options, this.token);
        }
    }



    public async export(options: TCMResponseDataItemOptions): Promise<any> {
        if (this.params.scheduleId) {
            return await this._service.exportGrid(this.token, options.dataQuery);
        }
        return null;
    }

    public async bulkUpdate(options: TCMResponseDataItemOptions): Promise<void> {
        if (this.params.scheduleId) {
            let updateParam: BulkUpdateRequest = {
                data: options.item as TCMResponseDataItem,
                filter: options.dataQuery?.filter,
                sort: []
            }
            await this._service.bulkUpdate(this.token, updateParam);
        }
    }

    public async history(options: TCMResponseDataItemOptions): Promise<ResultData<AuditHistory>> {
        if (this.params.scheduleId && options.rowId) {
             let fetchParams = this.buildFetchParams(options);
            this._service.params.scheduleId = options.scheduleId;
            let data = await this._service.history(fetchParams, options.rowId, this.token);
            return data;
        }
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }
}